import { ProductoService } from '@abm/producto/producto.service';
import { UsuarioService } from '@account/usuario.service';
import { formatDate } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, Input, LOCALE_ID, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, UntypedFormControl, ValidatorFn, Validators } from '@angular/forms';
import { CierreTurnoService } from '@cierreTurno/cierre-turno.service';
import { environment } from '@environments';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ErrorModel } from '@shared/models/ErrorModel';
import { forkJoin } from 'rxjs';
import { Aeroplanta } from '@shared/models/cierreTurno/Aeroplanta';
import {
  Tanque,
  Terminal,
  Transportista,
  CalidadProducto,
  DetalleProducto,
  RecepcionCombustibleContenedor,
  DetalleCombustible,
  Conductor,
  Responsable,
  Recepcion,
  RecepcionCamion,
  EstadoCisterna,
} from "@shared/models/stock";
import { SharedService } from '@shared/shared.service';
import { MessageService } from '@shell/message.service';
import { StockService } from '@stock/stock.service';
import { NuevaMedicionComponent } from '@stock/tableros/mediciones/nueva-medicion/nueva-medicion.component';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { MedicionCisternaComponent } from './medicion-cisterna/medicion-cisterna.component';

@Component({
  selector: 'app-recepcion-contingencia',
  templateUrl: './recepcion-contingencia.component.html',
  styleUrls: ['./recepcion-contingencia.component.scss']
})
export class RecepcionContingenciaComponent implements OnInit {

  recepcionForm: FormGroup;
  @Input() productos: any[];
  @Input() tanques: Tanque[];
  @Input() tanquesPorProducto?: Record<string, any[]>;
  @Input() recepcionCenit?: Recepcion;
  terminales: Terminal[];
  cargandoTerminales: boolean = false;
  fileRemito: File;
  recepcion: Recepcion;
  purgaCounter: number = 0;
  archivoSubido: string;
  puedeAgregarPurga: boolean = true;
  transportistas: Transportista[] = [];
  cargandoTransportistas: boolean;
  errorTransportistas: boolean;
  modelTransportista: any;
  conductores: Conductor[] = [];
  cargandoConductores: boolean;
  errorConductores: boolean;
  modelConductor: any;
  cargandoRecepcion: boolean;
  obteniendoAeroplanta: boolean;
  aeroplanta: Aeroplanta;
  listado: boolean;


  validaEtapa1: boolean;
  validaEtapa2: boolean;
  validaEtapa3: boolean;
  validaEtapa4: boolean;

  cisternaEstados: EstadoCisterna[][] = [];
  cisternasConfirmadas: boolean[] = [];
  totales: { natural: number; a15: number }[] = [];
  diferencias: ({ natural: number; a15: number } | null)[] = [];
  EstadoCisterna = EstadoCisterna;

  stockBaseUrl = environment.apiServer.stockBaseUrl;

  private readonly tolerancia: number = 0.0009;

  constructor(private fb: FormBuilder, private stockService: StockService, private modalService: NgbModal,
    private usuarioService: UsuarioService, @Inject(LOCALE_ID) public locale: string, private productoService: ProductoService,
    private sharedService: SharedService, private changeDetectorRef: ChangeDetectorRef, private messageService: MessageService,
    private cierresService: CierreTurnoService) {
    this.recepcionForm = this.fb.group({
      terminal: ['', Validators.required],
      prefijoRemito: ['', [Validators.required, this.prefijoRemitoValidator]],
      numeroRemito: ['', [Validators.required, this.numeroRemitoValidator]],
      cuitTransportista: ['', [Validators.required, this.validarCuit.bind(this)]],
      nombreTransportista: ['', Validators.required],
      domicilioTransportista: ['', Validators.required],
      dniConductor: ['', Validators.required],
      nombreConductor: ['', Validators.required],
      patenteCamion: ['', Validators.required],
      patenteAcoplado: [''],
      precintoFijo: [''],
      precintoDesde: [''],
      precintoHasta: [''],
      calidadProducto: this.fb.array([]),
      detalleCisternas: this.fb.array([]),
      medicionInicial: this.fb.array([]),
      medicionFinal: this.fb.array([])
    });
  }


  ngOnInit() {
    this.addFormCombustible();
    this.recepcion = new Recepcion();
    this.cargarDetalleProducto();
    this.getProductosDensidad();
    this.obtenerAeroplantaActual();
    this.recepcion.recepcionCombustibleContenedores = [];

    this.cargarDatosIniciales();
  }

  cargarDatosIniciales() {
    this.cargandoTerminales = this.cargandoTransportistas = this.cargandoConductores = true;

    forkJoin({
      terminales: this.stockService.getTerminales(),
      transportistas: this.stockService.getTransportistas(),
      conductores: this.stockService.getConductores()
    }).subscribe({
      next: ({ terminales, transportistas, conductores }) => {
        this.terminales = terminales;
        this.transportistas = transportistas.map(a => Object.assign(new Transportista(), a));
        this.conductores = conductores.map(a => Object.assign(new Conductor(), a));

        this.cargandoTerminales = this.cargandoTransportistas = this.cargandoConductores = false;

        if (this.recepcionCenit) {
          this.autocompletarRecepcionCenit();
        }
      },
      error: (err) => {
        console.error('Error cargando datos iniciales', err);
        this.cargandoTerminales = this.cargandoTransportistas = this.cargandoConductores = false;
      }
    });
  }



  inicializarCisternas() {
    this.cisternaEstados = [];

    this.detalleCisternas.controls.forEach((productoCtrl, i) => {
      const cisternasArray = productoCtrl as FormArray;
      this.cisternaEstados[i] = [];

      cisternasArray.controls.forEach((_, j) => {
        this.cisternaEstados[i][j] = EstadoCisterna.PENDIENTE;
      });
    });
  }

  toggleRecibirCisterna(i: number, j: number) {
    const estadoActual = this.cisternaEstados[i][j];
    this.cisternaEstados[i][j] =
      estadoActual === EstadoCisterna.RECIBIDO
        ? EstadoCisterna.PENDIENTE
        : EstadoCisterna.RECIBIDO;
    this.actualizarTotales(i);
  }

  toggleRechazarCisterna(i: number, j: number) {
    const estadoActual = this.cisternaEstados[i][j];
    this.cisternaEstados[i][j] =
      estadoActual === EstadoCisterna.RECHAZADO
        ? EstadoCisterna.PENDIENTE
        : EstadoCisterna.RECHAZADO;
    this.actualizarTotales(i);
  }
  recibirTotal(i: number) {
    const cisternasArray = this.detalleCisternas.at(i) as FormArray;

    if (!this.cisternaEstados[i]) this.cisternaEstados[i] = [];

    cisternasArray.controls.forEach((_, j) => {
      this.cisternaEstados[i][j] = EstadoCisterna.RECIBIDO;
    });

    this.actualizarTotales(i);
  }


  actualizarTotales(i: number) {
    const cisternasArray = this.detalleCisternas.at(i) as FormArray;
    let natural = 0;
    let a15 = 0;

    cisternasArray.controls.forEach((ctrl, j) => {
      const vol = Number(ctrl.get('volumen')?.value || 0);
      const vol15 = Number(ctrl.get('volumen15')?.value || 0);

      if (this.cisternaEstados?.[i]?.[j] === EstadoCisterna.RECIBIDO) {
        natural += vol;
        a15 += vol15;
      }
    });

    this.totales[i] = { natural, a15 };
    this.verificarDiferencias(i);

    this.actualizarVolumenEnMedicion(i, natural, a15);

    this.actualizarMedicionesDesdeTotales(i);
  }

  actualizarVolumenEnMedicion(i: number, volumenNatural: number, volumen15: number) {
    const medicionInicialGrupo = this.medicionInicial.at(i) as FormGroup;

    medicionInicialGrupo.get('volumenNaturalRemitoMedicionInicial')?.setValue(volumenNatural, { emitEvent: false });
    medicionInicialGrupo.get('volumen15RemitoMedicionInicial')?.setValue(volumen15, { emitEvent: false });


  }


  actualizarMedicionesDesdeTotales(i: number) {
    const total = this.totales[i];
    if (!total) return;

    const medicionInicialGrupo = this.medicionInicial.at(i) as FormGroup;
    const medicionFinalGrupo = this.medicionFinal.at(i) as FormGroup;

    if (medicionInicialGrupo) {
      if (!medicionInicialGrupo.get('volumenNaturalRemitoMedicionInicial')?.value) {
        medicionInicialGrupo.get('volumenNaturalRemitoMedicionInicial')
          ?.setValue(this.calidadProducto.at(i).get('volumenNaturalRemito')?.value ?? 0);
      }

      medicionInicialGrupo.get('volumen15RemitoMedicionInicial')
        ?.setValue(total.a15);
    }

    if (medicionFinalGrupo) {
      medicionFinalGrupo.get('volumen15RemitoMedicionFinal')
        ?.setValue(total.a15);
    }

    this.changeDetectorRef.detectChanges();
  }

  verificarDiferencias(i: number) {
    const cisternasArray = this.detalleCisternas.at(i) as FormArray;
    let naturalRecibido = 0;
    let a15Recibido = 0;

    cisternasArray.controls.forEach((ctrl, j) => {
      if (this.cisternaEstados?.[i]?.[j] === EstadoCisterna.RECIBIDO) {
        naturalRecibido += Number(ctrl.get('volumen')?.value || 0);
        a15Recibido += Number(ctrl.get('volumen15')?.value || 0);
      }
    });

    const remitoNatural = Number(this.calidadProducto.at(i).get('volumenNaturalRemito')?.value || 0);
    const remito15 = Number(this.calidadProducto.at(i).get('volumen15Remito')?.value || 0);

    const difNat = naturalRecibido - remitoNatural;
    const dif15 = a15Recibido - remito15;

    this.diferencias[i] = this.superanTolerancia(difNat, 0) || this.superanTolerancia(dif15, 0)
      ? { natural: difNat, a15: dif15 }
      : null;
  }

  confirmarCisternas(i: number): void {
    this.cisternasConfirmadas[i] = true;

    this.actualizarTotales(i);

    const totalNaturalAprobado = this.getTotalNatual(i);
    const medicionInicialGrupo = this.medicionInicial.at(i) as FormGroup;

    if (medicionInicialGrupo) {
      const valorFormateado = totalNaturalAprobado.toLocaleString('es-AR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 3,
        useGrouping: true
      }).replace(/,/g, '.');

      medicionInicialGrupo.get('volumenNaturalRemitoMedicionInicial')?.setValue(valorFormateado);

      this.productos[i].volumenNaturalRemito = totalNaturalAprobado;
    }

    this.messageService.showSuccessMessage(`Cisternas del producto ${this.productos[i].nombreProducto} confirmadas.`);

    this.changeDetectorRef.detectChanges();
  }

  eliminarCisterna(i: number, j: number): void {
    if (this.recepcionCenit || this.cisternasConfirmadas?.[i]) return;
    const cisternasArray = this.detalleCisternas.at(i) as FormArray;
    if (!cisternasArray || j < 0 || j >= cisternasArray.length) return;

    cisternasArray.removeAt(j);

    if (this.cisternaEstados?.[i]) {
      this.cisternaEstados[i].splice(j, 1);
    }

    this.actualizarTotales(i);

    this.changeDetectorRef.detectChanges();
    this.messageService?.showSuccessMessage?.('Cisterna eliminada.');
  }


  async obtenerAeroplantaActual() {
    this.obteniendoAeroplanta = true;
    this.aeroplanta = await this.cierresService.getAeroplantas(this.usuarioService.getAeroplantaActual().codigoAeroplanta);
    this.obteniendoAeroplanta = false;
  }

  cargarDetalleProducto() {
    this.recepcion.detalleProductos = [];
    this.productos.forEach(p => {
      {
        const detalleProducto = new DetalleProducto();
        detalleProducto.cantidad = 0,
          detalleProducto.codigoProducto = p.codigoProducto,
          detalleProducto.nombreProducto = p.nombreProducto,
          detalleProducto.tipoProducto = p.tipoProducto,
          detalleProducto.calidadProducto = new CalidadProducto(),
          detalleProducto.detalleCombustible = new DetalleCombustible(),
          detalleProducto.detalleCisternas = [],
          detalleProducto.id = p.id
        this.recepcion.detalleProductos.push(detalleProducto)
        p.medicion15 = 0;
        p.medicionNaturalPrevia = 0;
        p.medicion15Previa = 0;
        p.medicion15Final = 0;
        p.medicion15Remito = 0;
        p.densidadMin = 0;
        p.densidadMax = 0;
        p.recibeProducto = true;
        p.puedeAgregarPurga = true;
        p.purgaCounter = 0;
        p.resultadoPurga = "";
        p.medicionesIniciales = [];
        p.medicionesFinales = [];
      }
    })
  }

  cancelar() {
    if (this.listado) {
      this.modalService.dismissAll('cancel');
    } else {
      this.stockService.setGoBack = false;
    }
  }

  private addFormCombustible() {
    this.productos.forEach((p) => {
      const calidadProductoForm = this.fb.group({
        densidadRemito: ['', Validators.required],
        volumen15Remito: ['', [Validators.required, this.validNumberValidator()]],
        volumenNaturalRemito: ['', [Validators.required, this.validNumberValidator()]],
        nroCertificadoAnalisis: ['', Validators.required],
        conductividad: [
          0,
          p.codigoProducto === '205000'
            ? []
            : [Validators.required, this.conductividadValidator]
        ], temperaturaMuestra: ['', [Validators.required, this.validNumberValidator()]],
        densidadMuestra: ['', Validators.required],
        diferenciaDensidad: [{ value: '', disabled: true }],
        tolerancia: [{ value: '', disabled: true }],
        pruebaAgua: [true],
        indicadorContaminantesSolidos: [1, Validators.required],
        indicadorHumedad: ['A', Validators.required],
        aptoProducto: [false]
      });

      const detalleCisternasArray = this.fb.array(
        (p.detalleCisternas ?? []).map(c =>
          this.fb.group({
            codigo: [c.codigo],
            volumen: [c.volumen],
            volumen15: [c.volumen15],
            estado: [c.estado ?? EstadoCisterna.PENDIENTE]
          })
        )
      );


      const medicionInicialForm = this.fb.group({
        volumen15RemitoMedicionInicial: [{ value: '', disabled: true }],
        volumenNaturalRemitoMedicionInicial: [{ value: '', disabled: true }],
        volumenDatosMedicionInicial: [''],
        vacioDatosMedicionInicial: [''],
        volumenNaturalAIngresarMedicionInicial: [''],
        volumen15AIngresarMedicionInicial: [''],
        vacioSuficienteMedicionInicial: [false]
      });

      const medicionFinalForm = this.fb.group({
        volumen15RemitoMedicionFinal: [{ value: '', disabled: true }],
        densidadRemitoMedicionFinal: [{ value: '', disabled: true }],
        volumenNaturalDatosMedicionFinal: [''],
        vacioDatosMedicionFinal: [''],
        temperaturaRemitoMedicionFinal: [{ value: '', disabled: true }],
        totalMedicionA15: [''],
        diferenciaMedicionFinal: ['']
      });

      if (p.codigoProducto !== '205000') { calidadProductoForm.get('conductividad').disable() }

      this.calidadProducto.push(calidadProductoForm);
      this.detalleCisternas.push(detalleCisternasArray);
      this.medicionInicial.push(medicionInicialForm);
      this.medicionFinal.push(medicionFinalForm);
    })
  }


  autocompletarRecepcionCenit() {
    const r = this.recepcionCenit;
    if (!r) return;

    const terminalSeleccionada = this.terminales.find(t => t.codigoTerminal === r.codigoTerminal);
    if (terminalSeleccionada) this.terminal.setValue(terminalSeleccionada);

    this.prefijoRemito.setValue(r.prefijoRemitoCargamento ?? '');
    this.numeroRemito.setValue(r.numeroRemitoCargamento ?? '');

    const t = r.detalleCamion;

    if (t) {
      this.cuitTransportista.setValue({
        cuit: t.cuitTransportista ?? '',
        nombre: t.nombreTransportista ?? '',
        domicilio: t.domicilioTransportista ?? ''
      });

      this.nombreTransportista.setValue(t.nombreTransportista ?? '');
      this.domicilioTransportista.setValue(t.domicilioTransportista ?? '');

      this.dniConductor.setValue({
        documento: t.documentoConductor ?? '',
        nombre: t.nombreConductor ?? ''
      });

      this.nombreConductor.setValue(t.nombreConductor ?? '');
      this.patenteCamion.setValue(t.patenteCamion ?? '');
      this.patenteAcoplado.setValue(t.patenteAcoplado ?? '');
      this.precintoFijo.setValue(t.precintoFijo ?? '');
      this.precintoDesde.setValue(t.precintoDesdeCamion ?? '');
      this.precintoHasta.setValue(t.precintoHastaCamion ?? '');
    }

    if (r.detalles?.length) {
      r.detalles.forEach((p, i) => {
        const grupo = this.calidadProducto.at(i);
        if (grupo) {
          grupo.patchValue({
            densidadRemito: this.sharedService.formatDensidadRemitoAuto(p.detalleCombustible?.densidad ?? ''),
            volumenNaturalRemito: Number(p.cantidad ?? null),
            volumen15Remito: Number(p.detalleCombustible?.cantidad15 ?? null)
          });


          grupo.get('densidadRemito')?.disable();
          grupo.get('volumenNaturalRemito')?.disable();
          grupo.get('volumen15Remito')?.disable();
          grupo.get('tolerancia')?.setValue(0.004, { emitEvent: false });

          this.obtenerDiferenciaDensidad(i);

        }
      });
    }

    if (this.medicionFinal?.length) {
      this.productos.forEach((producto, i) => {
        const grupoFinal = this.medicionFinal.at(i);
        if (!grupoFinal) return;

        const densCtrl = grupoFinal.get('densidadRemitoMedicionFinal');
        const volCtrl = grupoFinal.get('volumen15RemitoMedicionFinal');

        const datosProducto = r.detalles.find(d => d.codigoProducto === producto.codigoProducto);
        if (!datosProducto?.detalleCombustible) return;

        const densidadRemito = datosProducto.detalleCombustible.densidad ?? '';
        const volumen15Remito = datosProducto.detalleCombustible.cantidad15 ?? '';

        if (densCtrl) {
          densCtrl.setValue(this.sharedService.formatDensidadRemitoAuto(densidadRemito), { emitEvent: false });
        }

        if (volCtrl) {
          volCtrl.setValue(this.sharedService.formatVolumenAuto(volumen15Remito), { emitEvent: false });
        }

      });
    }

    this.disableTypeaheads();
    this.bloquearCamposAutocompletados();
    this.archivoSubido = r.pathRemitoFisico ?? '';
    this.inicializarCisternas();
  }



  formatDensidadRemito(event: KeyboardEvent, i: number) {
    if (event.charCode == 8 || event.charCode == 0) return null;

    if (event.charCode >= 48 && event.charCode <= 57) {
      const valor = this.sharedService.formatDensidad2(event);
      const valorFormateado = this.sharedService.formatDensidadRemitoAuto(valor);
      this.calidadProducto.at(i).get('densidadRemito')?.setValue(valorFormateado);
      this.validarDensidad(valorFormateado, i, 'densidadRemito');
    }
    return false;
  }

  formatDensidadMuestra(event: KeyboardEvent, i: number) {
    if (event.charCode == 8 || event.charCode == 0) return null;

    if (event.charCode >= 48 && event.charCode <= 57) {
      const valor = this.sharedService.formatDensidadRecepcion(event);
      const valorFormateado = this.sharedService.formatDensidadMuestraAuto(valor);
      this.calidadProducto.at(i).get('densidadMuestra')?.setValue(valorFormateado);
      this.validarDensidad(valorFormateado, i, 'densidadMuestra');
    }
    return false;
  }

  disableTypeaheads() {
    this.cuitTransportista.clearValidators();
    this.dniConductor.clearValidators();

    this.cuitTransportista.setValidators(Validators.required);
    this.dniConductor.setValidators(Validators.required);

    this.cuitTransportista.updateValueAndValidity({ emitEvent: false });
    this.dniConductor.updateValueAndValidity({ emitEvent: false });
  }

  bloquearCamposAutocompletados() {
    this.terminal.disable();
    this.prefijoRemito.disable();
    this.numeroRemito.disable();
    this.cuitTransportista.disable();
    this.nombreTransportista.disable();
    this.domicilioTransportista.disable();
    this.dniConductor.disable();
    this.nombreConductor.disable();
    this.patenteCamion.disable();
    this.patenteAcoplado.disable();
    if (this.precintoFijo.value) this.precintoFijo.disable();
    if (this.precintoDesde.value) this.precintoDesde.disable();
    if (this.precintoHasta.value) this.precintoHasta.disable();
  }


  chequearCalidadProductoValido(i) {
    const formGroup = this.calidadProducto.at(i) as FormGroup;
    (formGroup.valid || !this.productos[i].recibeProducto) ? this.productos[i].validoCalidad = true : this.productos[i].validoCalidad = false;
    this.changeDetectorRef.detectChanges();
  }

  agregarPurga(i) {
    this.productos[i].purgaCounter += 1;
    const stringPurga = this.calidadProducto.at(i).get('indicadorContaminantesSolidos').value + this.calidadProducto.at(i).get('indicadorHumedad').value
    this.recepcion.detalleProductos[i].calidadProducto.resultadoPurga ?
      this.recepcion.detalleProductos[i].calidadProducto.resultadoPurga += ";" + stringPurga :
      this.recepcion.detalleProductos[i].calidadProducto.resultadoPurga = stringPurga;
    if (this.recepcion.detalleProductos[i].calidadProducto.resultadoPurga.endsWith("1A") || this.productos[i].purgaCounter == 3) {
      this.productos[i].puedeAgregarPurga = false;
    }
    this.productos[i].resultadoPurga = stringPurga;
  }

  getProductosDensidad() {
    this.productoService.obtenerProductos()
      .subscribe(result => {
        result.forEach(r => {
          this.productos.forEach(p => {
            if (p.codigoProducto == r.codigoProducto) {
              p.densidadMin = r.densidadMin;
              p.densidadMax = r.densidadMax;
            }
          })
        })
      });
  }

  borrarMedicionPrevia(recepcionCombustible, i, iMedicion) {
    this.productos[i].medicion15Remito = this.calidadProducto.at(i).get('volumen15Remito').value;
    this.productos[i].medicionesIniciales.splice(iMedicion, 1);
    let recepcion = null;
    let pos = -1;
    for (let i = 0; i < this.recepcion.recepcionCombustibleContenedores.length; i++) {
      if (this.recepcion.recepcionCombustibleContenedores[i].codigoTanque == recepcionCombustible.codigoContenedor) {
        recepcion = this.recepcion.recepcionCombustibleContenedores[i];
        pos = i;
      }
    }
    this.productos[i].medicion15Previa -= recepcion.medicionPrevia.nivel;
    this.productos[i].medicionNaturalPrevia -= recepcion.medicionPrevia.nivelNatural;
    recepcion.medicionPrevia = null;

    this.recepcion.recepcionCombustibleContenedores.splice(pos, 1);
  }

  borrarMedicionFinal(recepcionCombustible, i, iMedicion) {
    this.productos[i].medicion15Remito = this.calidadProducto.at(i).get('volumen15Remito').value;
    this.productos[i].medicionesFinales.splice(iMedicion, 1);
    let recepcion = null;
    this.recepcion.recepcionCombustibleContenedores.forEach(r => {
      if (r.codigoTanque == recepcionCombustible.codigoContenedor) {
        recepcion = r;
      }
    })
    this.productos[i].medicion15Final -= recepcion.medicionFinal.nivel;
    recepcion.medicionFinal = null;
  }


  agregarMedicionInicial(i: number) {
    this.productos[i].medicion15Remito = this.calidadProducto.at(i).get('volumen15Remito').value;

    const codigo = this.productos[i].codigoProducto;
    const baseTanques = this.tanquesPorProducto?.[codigo] ?? this.tanques ?? [];

    const tanquesFiltrados = baseTanques.filter(t =>
      t.productoActual?.codigoProducto === codigo &&
      !this.productos[i].medicionesIniciales.some(m => m.tanque === t.nombre) &&
      !this.productos[i].medicionesFinales.some(m => m.nombreTanque === t.nombre)
    );

    if (tanquesFiltrados.length === 0) {
      this.messageService.showWarningMessage('No hay tanques disponibles para este producto en la aeroplanta.', false);
      return;
    }

    const modalRef = this.modalService.open(NuevaMedicionComponent, { centered: true });
    modalRef.componentInstance.aeroplanta = this.aeroplanta;
    modalRef.componentInstance.tanques = tanquesFiltrados;
    modalRef.componentInstance.esRecepcionContingencia = true;

    modalRef.result.then((result) => {
      if (!result) return;

      this.productos[i].medicion15Previa += result.nivel;
      this.productos[i].medicionNaturalPrevia += result.nivelNatural;

      let recepcionContenedor = this.recepcion.recepcionCombustibleContenedores
        ?.find(r => r.codigoTanque === result.codigoContenedor);

      if (!recepcionContenedor) {
        recepcionContenedor = new RecepcionCombustibleContenedor();
        this.recepcion.recepcionCombustibleContenedores.push(recepcionContenedor);
      }

      const tanque = this.tanques.find(t => t.codigo === result.codigoContenedor);

      recepcionContenedor.medicionPrevia = result;
      recepcionContenedor.codigoTanque = tanque?.codigo || result.codigoContenedor;
      recepcionContenedor.codigoProducto = tanque?.productoActual?.codigoProducto || codigo;
      recepcionContenedor.vacio = (tanque?.capacidad ?? 0) - result.nivelNatural;

      recepcionContenedor.cantidad = 0;
      recepcionContenedor.cantidad15 = 0;

      const medicion = {
        ...result,
        tanque: tanque?.nombre || `Tanque ${result.codigoContenedor}`,
        vacio: recepcionContenedor.vacio,
        nivelNatural: result.nivelNatural,
        codigoContenedor: result.codigoContenedor,
        medicionNaturalAIngresar: 0,
        medicion15AIngresar: 0
      };

      this.productos[i].medicionesIniciales.push(medicion);
    }).catch(() => {
    });

    this.changeDetectorRef.detectChanges();
  }



  verificarConductividad(i) {
    const conductividad = this.calidadProducto.at(i).get('conductividad').value;
    if (conductividad > 50 || conductividad < 600) {
      return false
    } else return true;
  }

  verificarApto(i) {
    const producto = this.productos[i];
    const densidadFueraTolerancia = Math.abs(this.calidadProducto.at(i).get('diferenciaDensidad').value) > 0.004;
    if (producto.codigoProducto == '205000') {
      if (this.productos[i].resultadoPurga.endsWith('1A') && this.calidadProducto.at(i).get('pruebaAgua').value == false && !densidadFueraTolerancia && (this.calidadProducto.at(i).get('conductividad').value > 50 || this.calidadProducto.at(i).get('conductividad').value < 600)) {
        this.calidadProducto.at(i).get('aptoProducto').setValue(true);
        return true
      } else {
        this.calidadProducto.at(i).get('aptoProducto').setValue(false);
        return false
      }
    } else {
      if (this.productos[i].resultadoPurga.endsWith('1A') && this.calidadProducto.at(i).get('pruebaAgua').value == false && !densidadFueraTolerancia) {
        this.calidadProducto.at(i).get('aptoProducto').setValue(true);
        return true
      } else {
        this.calidadProducto.at(i).get('aptoProducto').setValue(false);
        return false
      }
    }
  }

  agregarMedicionFinal(i: number) {
    const producto = this.productos[i];
    if (!producto?.medicionesIniciales?.length) {
      this.messageService.showWarningMessage('Debe registrar mediciones iniciales antes de cargar las finales.');
      return;
    }

    const codigo = producto.codigoProducto;
    const baseTanques = this.tanquesPorProducto?.[codigo] ?? this.tanques ?? [];

    const tanquesPendientesFinal = baseTanques.filter(tanque =>
      producto.medicionesIniciales.some(m => m.tanque === tanque.nombre) &&
      !producto.medicionesFinales.some(f => f.tanque === tanque.nombre)
    );

    if (tanquesPendientesFinal.length === 0) {
      this.messageService.showWarningMessage('Ya se cargaron las mediciones finales de todos los tanques.', false);
      return;
    }

    const modalRef = this.modalService.open(NuevaMedicionComponent, { centered: true });
    modalRef.componentInstance.aeroplanta = this.aeroplanta;
    modalRef.componentInstance.tanques = tanquesPendientesFinal;
    modalRef.componentInstance.esRecepcionContingencia = true;

    modalRef.result.then((result) => {
      if (!result) return;

      const recepcionContenedor = this.recepcion.recepcionCombustibleContenedores.find(
        r => r.codigoTanque === result.codigoContenedor
      );

      if (recepcionContenedor) {
        recepcionContenedor.medicionFinal = result;
      } else {
        const nuevo = new RecepcionCombustibleContenedor();
        nuevo.codigoTanque = result.codigoContenedor;
        nuevo.medicionFinal = result;
        this.recepcion.recepcionCombustibleContenedores.push(nuevo);
      }

      const tanque = baseTanques.find(t => t.codigo === result.codigoContenedor);
      if (tanque) {
        result.tanque = tanque.nombre;
        const vacio = tanque.capacidad - result.nivelNatural;
        result.vacio = vacio;
      }

      producto.medicionesFinales.push(result);
      producto.medicion15Final += result.nivel;

      this.changeDetectorRef.detectChanges();
      this.messageService.showSuccessMessage(`Medición final cargada para el tanque ${result.tanque}.`);
    }).catch(() => { });
  }


  abrirModalAgregarMedicion(i: number) {
    const modalRef = this.modalService.open(MedicionCisternaComponent, {
      centered: true,
      size: 'sm'
    });

    modalRef.result.then(result => {
      if (result) {
        const cisternasArray = this.getCisternas(i);
        const nuevaCisterna = this.fb.group({
          codigo: [result.codigo],
          volumen: [result.volumen],
          volumen15: [result.volumen15],
          estado: [EstadoCisterna.PENDIENTE]
        });

        cisternasArray.push(nuevaCisterna);

        if (!this.cisternaEstados[i]) this.cisternaEstados[i] = [];
        this.cisternaEstados[i][cisternasArray.length - 1] = EstadoCisterna.PENDIENTE;

        this.actualizarTotales(i);
        this.changeDetectorRef.detectChanges();
        this.messageService.showSuccessMessage('Medición agregada correctamente.');
      }
    }).catch(() => { });
  }



  onArchivoSubido(event) {
    const remitoFisico = event;
    this.archivoSubido = remitoFisico;
  }

  validarTotalesMedicionIniciales(): boolean {
    return this.productos.every(producto => {
      return producto.medicionesIniciales.every((medicion, index) => {
        const sumaNatural = medicion.medicionNaturalAIngresar;
        const suma15 = medicion.medicion15AIngresar;
        const totalNatural = this.getTotalNatual(index);
        const total15 = this.getTotal15(index);
        return sumaNatural === totalNatural && suma15 === total15;
      });
    });
  }

  cargarRecepcion() {
    // Validamos que el formulario sea válido
    if (!this.recepcionForm.valid) {
      this.messageService.showErrorMessage('Debe completar todos los campos obligatorios.');
      return;
    }

    // Validamos que se subio el archivo del remito fisico
    if (!this.archivoSubido) {
      this.messageService.showErrorMessage("Debe subir el archivo del remito fisico.");
      return;
    }

    // Validamos que todos los productos, no tengan "medicionesIniciales": []
    const faltanMedicionesIniciales = this.productos.every(producto => producto.medicionesIniciales.length === 0);
    if (faltanMedicionesIniciales) {
      this.messageService.showErrorMessage('Debe completar las mediciones iniciales de todos los tanques para continuar.');
      return;
    }

    // Validamos que todos los productos, no tengan "medicionesFinales": []
    const faltanMedicionesFinales = this.productos.every(producto => producto.medicionesFinales.length === 0);
    if (faltanMedicionesFinales) {
      this.messageService.showErrorMessage('Debe completar las mediciones finales de todos los tanques para continuar.');
      return;
    }

    // Validamos que la suma de los volúmenes a ingresar no coincida con la totalidad del remito
    if (!this.validarTotalesMedicionIniciales()) {
      const msg = "La suma de los volúmenes a ingresar no coincide a la totalidad del remito,\n"
      "por favor revise los datos ingresados o agregue otra medición inicial.";
      this.messageService.showErrorMessage(msg);
      return;
    }

    this.cargandoRecepcion = true;
    const recepcion = this.recepcion;
    recepcion.codigoTerminal = this.terminal.value.codigoTerminal;
    recepcion.codigoAeroplanta = this.usuarioService.getAeroplantaActual().codigoAeroplanta;
    recepcion.prefijoRemitoCargamento = Number(this.prefijoRemito.value);
    recepcion.numeroRemitoCargamento = Number(this.numeroRemito.value);

    const responsableDto = new Responsable()
    responsableDto.NombreCompleto = this.usuarioService.getNombresOperador();
    responsableDto.UserName = this.usuarioService.getUsername();
    responsableDto.DNI = this.usuarioService.getDniOperador();
    responsableDto.codigoUsuario = this.usuarioService.getIdUsuario();
    recepcion.responsableDto = responsableDto;

    const detalleCamion = new RecepcionCamion();
    if (typeof this.cuitTransportista.value === 'object') {
      detalleCamion.cuitTransportista = this.cuitTransportista.value.cuit;
      detalleCamion.domicilioTransportista = this.cuitTransportista.value.domicilio;
      detalleCamion.nombreTransportista = this.cuitTransportista.value.nombre;
    } else {
      detalleCamion.cuitTransportista = this.cuitTransportista.value;
      detalleCamion.domicilioTransportista = this.domicilioTransportista.value;
      detalleCamion.nombreTransportista = this.nombreTransportista.value;
    }
    detalleCamion.patenteCamion = this.patenteCamion.value;
    if (typeof this.dniConductor.value === 'object') {
      detalleCamion.documentoConductor = this.dniConductor.value.documento;
      detalleCamion.nombreConductor = this.dniConductor.value.nombre;
    } else {
      detalleCamion.documentoConductor = this.dniConductor.value;
      detalleCamion.nombreConductor = this.nombreConductor.value;
    }
    detalleCamion.precintoDesdeCamion = this.precintoDesde.value;
    detalleCamion.precintoHastaCamion = this.precintoHasta.value
    detalleCamion.precintoFijo = this.precintoFijo.value;
    detalleCamion.patenteAcoplado = this.patenteAcoplado.value;
    recepcion.detalleCamion = detalleCamion;
    recepcion.detalleProductos = this.recepcion.detalleProductos;

    for (let i = 0; i < this.productos.length; i++) {
      this.recepcion.detalleProductos[i].cantidad = Number(this.calidadProducto.at(i).get('volumenNaturalRemito').value);
      this.recepcion.detalleProductos[i].id = this.productos[i].id;
      this.recepcion.detalleProductos[i].codigoProducto = this.productos[i].codigoProducto;
      this.recepcion.detalleProductos[i].nombreProducto = this.productos[i].nombreProducto;
      this.recepcion.detalleProductos[i].tipoProducto = this.productos[i].tipoProducto;
      this.recepcion.detalleProductos[i].recibeProducto = this.productos[i].recibeProducto;
      this.recepcion.detalleProductos[i].calidadProducto.aptoCalidad = this.calidadProducto.at(i).get('aptoProducto').value;
      this.recepcion.detalleProductos[i].calidadProducto.conductividad = Number(this.calidadProducto.at(i).get('conductividad').value);
      this.recepcion.detalleProductos[i].calidadProducto.diferenciaDensidad = Number(this.calidadProducto.at(i).get('diferenciaDensidad').value);
      this.recepcion.detalleProductos[i].calidadProducto.densidad = Number(String(this.calidadProducto.at(i).get('densidadMuestra').value ?? '').replace(',', '.')) || 0;
      this.recepcion.detalleProductos[i].calidadProducto.temperatura = Number(this.calidadProducto.at(i).get('temperaturaMuestra').value);
      this.recepcion.detalleProductos[i].calidadProducto.numeroCertificadoAnalisis = this.calidadProducto.at(i).get('nroCertificadoAnalisis').value;
      this.recepcion.detalleProductos[i].detalleCombustible.cantidad15 = Number(this.calidadProducto.at(i).get('volumen15Remito').value);
      this.recepcion.detalleProductos[i].detalleCombustible.densidad = Number(String(this.calidadProducto.at(i).get('densidadRemito').value ?? '').replace(',', '.')) || 0;
    }
    recepcion.fechaHoraCreacion = formatDate(new Date(), 'y-MM-ddTHH:mm:ss', this.locale);
    recepcion.firmaConductor = "";
    recepcion.firmaOperador = "";
    recepcion.pathRemitoFisico = this.archivoSubido;

    const detalleProductosIniciar = [];
    this.recepcion.detalleProductos.forEach(d => {
      const p = new DetalleProducto()
      p.cantidad = 0;
      p.codigoProducto = d.codigoProducto,
        p.nombreProducto = d.nombreProducto,
        p.tipoProducto = d.tipoProducto
      detalleProductosIniciar.push(p);
    })

    const recepcionIniciar = {
      codigoAeroplanta: this.usuarioService.getAeroplantaActual().codigoAeroplanta,
      codigoTerminal: this.terminal.value.codigoTerminal,
      detalleCamionDTO: this.recepcion.detalleCamion,
      detalleProductos: detalleProductosIniciar,
      fechaHoraCreacion: this.recepcion.fechaHoraCreacion,
      pathRemitoFisico: this.recepcion.pathRemitoFisico,
      prefijoRecibo: 0,
      numeroRecibo: 0,
      prefijoRemitoCargamento: this.recepcion.prefijoRemitoCargamento,
      numeroRemitoCargamento: this.recepcion.numeroRemitoCargamento,
      recepcionCombustibleContenedores: [],
      responsableDto: this.recepcion.responsableDto
    }

    this.recepcion.recepcionCombustibleContenedores?.forEach(rc => {
      if (rc.medicionPrevia) rc.medicionPrevia.nivelAgua = 0;
      if (rc.medicionFinal) rc.medicionFinal.nivelAgua = 0;
    });


    const dto = {
      "iniciarRecepcionDto": recepcionIniciar,
      "recepcionCombustibleDto": recepcion,
      "esRecepcionAutomatica": this.recepcionCenit ? true : false
    }

    for (let i = 0; i < this.productos.length; i++) {
      const detalleCisternasArray = this.detalleCisternas.at(i) as FormArray;
      const producto = this.recepcion.detalleProductos[i];

      if (this.recepcionCenit) {
        const cisternasProcesadas = detalleCisternasArray.controls.map((ctrl, j) => {
          const estadoGuardado = this.cisternaEstados[i]?.[j];

          const estado: EstadoCisterna =
            typeof estadoGuardado === 'number'
              ? estadoGuardado
              : EstadoCisterna.PENDIENTE;

          return {
            codigo: ctrl.get('codigo')?.value,
            volumen: Number(ctrl.get('volumen')?.value),
            volumen15: Number(ctrl.get('volumen15')?.value),
            estado
          };
        });

        producto.detalleCisternas = cisternasProcesadas;
      } else {
        const cisternasManuales = detalleCisternasArray.controls.map((ctrl, j) => {
          const estadoGuardado = this.cisternaEstados[i]?.[j];

          const estado: EstadoCisterna =
            typeof estadoGuardado === 'number'
              ? estadoGuardado
              : EstadoCisterna.PENDIENTE;

          return {
            codigo: ctrl.get('codigo')?.value,
            volumen: Number(ctrl.get('volumen')?.value),
            volumen15: Number(ctrl.get('volumen15')?.value),
            estado
          };
        });

        producto.detalleCisternas = cisternasManuales;

      }
    }


    this.stockService.crearRecepcionContingencia(dto).subscribe(() => {
      setTimeout(() => this.cancelar(), 5000);
    }, (err: ErrorModel) => {
      this.messageService.showErrorMessage(`${err.description}. \n ${err.message}`);
      this.cargandoRecepcion = false;
    })
  }

  formatearVolumenAutocompletar(i: number, campo: string): void {
    const grupo = this.medicionInicial.at(i) as FormGroup;
    const ctrl = grupo?.get(campo);
    if (!ctrl) return;

    const valor = String(ctrl.value ?? '').replace(/\./g, '').replace(/\D/g, '');
    if (!valor) {
      ctrl.setValue('', { emitEvent: false });
      return;
    }

    const formateado = valor.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    ctrl.setValue(formateado, { emitEvent: false });
  }

  formatDensidadAviso(valor: number) {
    return valor.toLocaleString('es-AR', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
  }

  formatDensidad3(valor: any): string {
    const n = Number(String(valor ?? '').replace(',', '.'));
    if (isNaN(n)) return '';
    return n.toFixed(3).replace('.', ',');
  }


  obtenerDiferenciaDensidad(i: number) {
    const grupo = this.calidadProducto.at(i) as FormGroup;
    if (!grupo) return;

    const toNum = (v: any) => Number(String(v ?? '').replace(/\./g, '').replace(',', '.')) || 0;

    const densidadMuestraRaw = grupo.get('densidadMuestra')?.value;
    const temperaturaMuestraRaw = grupo.get('temperaturaMuestra')?.value;
    const densidadRemitoRaw = grupo.get('densidadRemito')?.value;

    if (!densidadMuestraRaw || densidadMuestraRaw.toString().trim() === '') {
      grupo.get('diferenciaDensidad')?.setValue(0);
      return;
    }

    const densidadMuestra = toNum(densidadMuestraRaw);
    const temperaturaMuestra = toNum(temperaturaMuestraRaw);
    const densidadRemito = toNum(densidadRemitoRaw);

    try {
      const densidad15 = this.obtenerDensidadNaturalEn15Grados(temperaturaMuestra, densidadMuestra);
      const dif = +(densidadRemito - densidad15).toFixed(3);
      grupo.get('diferenciaDensidad')?.setValue(dif);
    } catch {
      grupo.get('diferenciaDensidad')?.setValue(0);
    }
  }




  onVolumen15Remito(i) {
    this.medicionInicial.at(i).get('volumen15RemitoMedicionInicial').setValue(this.calidadProducto.at(i).get('volumen15Remito').value)
    this.medicionFinal.at(i).get('volumen15RemitoMedicionFinal').setValue(this.calidadProducto.at(i).get('volumen15Remito').value)
  }

  onVolumenNaturalRemito(i) {
    this.medicionInicial.at(i).get('volumenNaturalRemitoMedicionInicial').setValue(this.calidadProducto.at(i).get('volumenNaturalRemito').value)
  }

  onTemperaturaRemito(i) {
    this.medicionFinal.at(i).get('temperaturaRemitoMedicionFinal').setValue(this.calidadProducto.at(i).get('temperaturaRemito').value)
  }

  noRecibirProducto(i) {
    if (this.calidadProducto.at(i).valid && this.productos[i].resultadoPurga != "") {
      this.calidadProducto.at(i).disable();
      this.medicionInicial.at(i).disable();
      this.medicionFinal.at(i).disable();
      this.productos[i].recibeProducto = false;
    } else {
      this.messageService.showErrorMessage('Debe completar todos los datos del producto para continuar.')
    }
  }

  validarDensidad(valor: any, i: number, tipo: 'densidadRemito' | 'densidadMuestra' = 'densidadMuestra'): boolean {
    const grupo = this.calidadProducto?.at(i);
    if (!grupo) return true;

    const control = grupo.get(tipo);
    const producto = this.productos[i];
    if (!control || control.disabled || !producto) return true;

    if (producto.densidadMin == null || producto.densidadMax == null || producto.densidadMin === 0) return true;

    const v = Number(String(valor ?? '').replace(',', '.'));
    if (isNaN(v)) return true;

    return v >= producto.densidadMin && v <= producto.densidadMax;
  }


  searchTransportista = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => this.transportistas == null || term.length < 2 || this.cargandoTransportistas ? [] :
        this.transportistas.filter(t => this.containsString(this.cuitTransportista.value, t.cuit, t.nombre)).slice(0, 10))
    )
  formatterTransportistaResult = (x: { nombre: string, cuit: string }) => ` ${x.cuit == null ? 'SIN CUIT' : x.cuit} - ${x.nombre}`;

  formatterTransportistaInput = (x: { nombre: string, cuit: string }) => `${x.cuit}`;

  selectTransportista(event: any): void {
    const transportista = event.item;
    this.cuitTransportista.setValue(transportista.cuit);
    this.domicilioTransportista.setValue(transportista.domicilio);
    this.nombreTransportista.setValue(transportista.nombre);
  }

  searchConductor = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => this.conductores == null || term.length < 2 || this.cargandoConductores ? [] :
        this.conductores.filter(t => this.containsString(this.dniConductor.value, t.nombre, t.documento)).slice(0, 10))
    )

  formatterConductorResult = (x: { nombre: string, documento: string }) => ` ${x.documento == null ? 'SIN DOC.' : x.documento} - ${x.nombre}`;

  formatterConductorInput = (x: { nombre: string, documento: string }) => `${x.documento}`;

  selectConductor(event: any): void {
    const conductor = event.item;
    this.dniConductor.setValue(conductor.documento);
    this.nombreConductor.setValue(conductor.nombre);
  }

  pruebaAguaPositiva(i) {
    if (this.calidadProducto.at(i).get('pruebaAgua').value) {
      return false
    }
    return true;
  }

  prefijoRemitoValidator(control: UntypedFormControl) {
    if (control.value < 9999) {
      return null;
    }

    return { prefijoMenor4: true };
  }

  numeroRemitoValidator(control: UntypedFormControl) {
    if (control.value < 99999999) {
      return null;
    }
    return { numeroMenor8: true };
  }

  conductividadValidator(control: UntypedFormControl) {
    if (control.value >= 50 && control.value <= 600) {
      return null;
    }
    return { conductividadFueraDeRango: true }
  }

  validarConductividad(i) {
    if (this.productos[i].codigoProducto == '205000') {
      if (this.calidadProducto.at(i).get('conductividad').value < 50 || this.calidadProducto.at(i).get('conductividad').value > 600) {
        return false
      }
    }
    return true;
  }


  obtenerDensidadNaturalEn15Grados(temperatura: number, densidad: number): number {
    const p = densidad * 1000; // Convertir a kg/m^3

    const dT = temperatura - 15;
    const HYC = 1 - (0.000023 * dT) - (0.00000002 * Math.pow(dT, 2));
    const p15_base = p * HYC;

    let p15_final = p15_base;
    for (let i = 0; i < 18; i++) {
      let Alfa: number;
      if (p15_final >= 839) {
        Alfa = (186.9696 / Math.pow(p15_final, 2)) + (0.4862 / p15_final);
      } else if (p15_final >= 788) {
        Alfa = (594.5418 / Math.pow(p15_final, 2));
      } else if (p15_final > 770) {
        Alfa = -0.00336312 + (2680.3206 / Math.pow(p15_final, 2));
      } else {
        Alfa = (346.4228 / Math.pow(p15_final, 2)) + (0.4388 / p15_final);
      }

      const VCF = Math.exp((-Alfa * dT) - (0.8 * Math.pow(Alfa, 2) * Math.pow(dT, 2)));
      p15_final = p15_base / VCF;
    }

    const densidad_corregida = p15_final / 1000; // Convertir de kg/m^3 a g/cm^3

    return densidad_corregida;
  }

  parseDensidad(valor: any): number {
    if (valor === null || valor === undefined) return NaN;
    const limpio = String(valor).replace(',', '.');
    const num = Number(limpio);
    return isNaN(num) ? NaN : num;
  }

  parseValor(v: any): number {
    if (v == null || v === '') return 0;
    return Number(String(v).replace(/\./g, '').replace(',', '.')) || 0;
  }

  noCoincideMedicion(i: number): boolean {
    const { natural: medicionNaturalSuma, a15: medicion15Suma } = this.calcularTotalesMedicionInicial(i);
    const totalNatural = this.getTotalNatual(i);
    const total15 = this.getTotal15(i);

    // Evita mostrar mensaje si no se cargó nada
    if (totalNatural === 0 && total15 === 0) {
      return false;
    }

    return this.superanTolerancia(medicionNaturalSuma, totalNatural) || this.superanTolerancia(medicion15Suma, total15);
  }

  superanTolerancia(valor1: number, valor2: number): boolean {
    return Math.abs(valor1 - valor2) > this.tolerancia;
  }

  calcularTotalesMedicionInicial(productoIndex: number) {
    return this.productos[productoIndex].medicionesIniciales.reduce((acc, m) => {
      const nat = Number(m.medicionNaturalAIngresar || 0);
      const a15 = Number(m.medicion15AIngresar || 0);
      return { natural: acc.natural + nat, a15: acc.a15 + a15 };
    }, { natural: 0, a15: 0 });
  }

  coincidenTotalesConRemito(i: number): boolean {
    const dif = this.getDiferenciasVolumen(i);
    if (!dif) return true;

    return dif.diferenciaNatural === 0 && dif.diferenciaA15 === 0;
  }

  getDiferenciasVolumen(i: number) {
    const calidad = this.calidadProducto.at(i);
    const cisternasArray = this.detalleCisternas.at(i) as FormArray;
    if (!calidad || !cisternasArray) return null;

    const parseVol = (v: any) =>
      Number(String(v ?? '').replace(/\./g, '').replace(',', '.')) || 0;

    const volumenNaturalRemito = parseVol(calidad.get('volumenNaturalRemito')?.value);
    const volumen15Remito = parseVol(calidad.get('volumen15Remito')?.value);

    let naturalRecibido = 0;
    let a15Recibido = 0;
    let naturalRechazado = 0;
    let a15Rechazado = 0;

    cisternasArray.controls.forEach((ctrl, j) => {
      const vol = parseVol(ctrl.get('volumen')?.value);
      const vol15 = parseVol(ctrl.get('volumen15')?.value);
      const estado = this.cisternaEstados?.[i]?.[j];

      if (estado === EstadoCisterna.RECIBIDO) {
        naturalRecibido += vol;
        a15Recibido += vol15;
      } else if (estado === EstadoCisterna.RECHAZADO) {
        naturalRechazado += vol;
        a15Rechazado += vol15;
      }
    });

    const diferenciaNatural = +(((volumenNaturalRemito - naturalRechazado) - naturalRecibido).toFixed(3));
    const diferenciaA15 = +(((volumen15Remito - a15Rechazado) - a15Recibido).toFixed(3));

    if (Math.abs(diferenciaNatural) < 0.001 && Math.abs(diferenciaA15) < 0.001) return null;

    return { diferenciaNatural, diferenciaA15 };
  }

  setMedicionNaturalAIngresar(valor: number, i: number, iMedicion: number) {
    const medicion = this.productos[i].medicionesIniciales[iMedicion];
    medicion.medicionNaturalAIngresar = Number(valor) || 0;

    this.recepcion.recepcionCombustibleContenedores.forEach(r => {
      if (r.codigoTanque === medicion.codigoContenedor) {
        r.cantidad = Number(valor) || 0;
      }
    });

    this.validarSumaMediciones(i);
  }

  setMedicion15AIngresar(valor: number, i: number, iMedicion: number) {
    const medicion = this.productos[i].medicionesIniciales[iMedicion];
    medicion.medicion15AIngresar = Number(valor) || 0;

    this.recepcion.recepcionCombustibleContenedores.forEach(r => {
      if (r.codigoTanque === medicion.codigoContenedor) {
        r.cantidad15 = Number(valor) || 0;
      }
    });

    this.validarSumaMediciones(i);
  }

  validarSumaMediciones(i: number) {

    let totalNatural = 0;
    let total15 = 0;


    this.recepcion.recepcionCombustibleContenedores.forEach((r) => {
      const coincide = this.productos[i].codigoProducto === r.codigoProducto;

      if (coincide) {
        totalNatural += Number(r.cantidad || 0);
        total15 += Number(r.cantidad15 || 0);
      }
    });


    const volumenNaturalRemito = Number(this.calidadProducto.at(i).get('volumenNaturalRemito')?.value || 0);
    const volumen15Remito = Number(this.calidadProducto.at(i).get('volumen15Remito')?.value || 0);


    const difNatural = +(totalNatural - volumenNaturalRemito).toFixed(3);
    const dif15 = +(total15 - volumen15Remito).toFixed(3);


    const tieneDif = this.superanTolerancia(difNatural, 0) || this.superanTolerancia(dif15, 0);

    this.diferencias[i] = tieneDif
      ? { natural: difNatural, a15: dif15 }
      : null;
  }

  validarMedicionPrevia(i) {
    if (this.productos[i].medicionesFinales.length !== 0) {
      return true
    } else return false
  }

  containsString(searchValue: string, ...searchIn: string[]): boolean {
    const concat = searchIn.toString();
    return concat.toLowerCase().indexOf(searchValue.toLowerCase()) > -1
  }

  validarFormatoCuit(): boolean {
    const regexCuit = /^(20|23|24|27|30|33|34)([0-9]{9}|[0-9]{8}[0-9]{1})$/g;
    const p = regexCuit.test(this.cuitTransportista.value)
    return p;
  }

  validNumberValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const valid = /^[0-9.-]+$/.test(control.value);
      return valid ? null : { 'invalidNumber': { value: control.value } };
    };
  }

  validarCuit(control: AbstractControl): { [key: string]: any } | null {
    if (control.value == null || control.value.length === 0 || typeof control.value === 'object') {
      return null; // don't validate empty values to allow optional controls
    }
    let esCuit = false;
    let cuit = control.value
    const vec = new Array(10);
    let cuit_rearmado = "";
    for (let i = 0; i < cuit.length; i++) {
      const caracter = cuit.charAt(i);
      if (caracter.charCodeAt(0) >= 48 && caracter.charCodeAt(0) <= 57) {
        cuit_rearmado += caracter;
      }
    }
    cuit = cuit_rearmado;
    if (cuit.length != 11) {  // si no estan todos los digitos
      esCuit = false;
    } else {
      let x = 0;
      let dv = 0
      // Multiplico los dígitos.
      vec[0] = cuit.charAt(0) * 5;
      vec[1] = cuit.charAt(1) * 4;
      vec[2] = cuit.charAt(2) * 3;
      vec[3] = cuit.charAt(3) * 2;
      vec[4] = cuit.charAt(4) * 7;
      vec[5] = cuit.charAt(5) * 6;
      vec[6] = cuit.charAt(6) * 5;
      vec[7] = cuit.charAt(7) * 4;
      vec[8] = cuit.charAt(8) * 3;
      vec[9] = cuit.charAt(9) * 2;

      // Suma cada uno de los resultado.
      for (let i = 0; i <= 9; i++) {
        x += vec[i];
      }
      dv = (11 - (x % 11)) % 11;
      if (dv == cuit.charAt(10)) {
        esCuit = true;
      }
    }

    return control.valid && esCuit ? null : { 'cuit': { value: control.value } };
  }

  autocompletarTransportistaPorCuit(cuit: string) {
    const t = this.transportistas.find(x => x.cuit === cuit);
    if (t) {
      this.nombreTransportista.setValue(t.nombre);
      this.domicilioTransportista.setValue(t.domicilio);
      this.cuitTransportista.setValue(t.cuit);
    }
  }

  autocompletarConductorPorDni(dni: string) {
    const c = this.conductores.find(x => x.documento === dni);
    if (c) {
      this.nombreConductor.setValue(c.nombre);
    }
  }

  getCisternas(i: number): FormArray {
    return this.detalleCisternas.at(i) as FormArray;
  }

  todasCisternasConfirmadas(): boolean {
    if (!this.cisternasConfirmadas) return true;
    return this.cisternasConfirmadas?.length > 0 && this.cisternasConfirmadas.every(c => c);
  }

  getTotalMedicion15(i: number): number {
    const prod = this.productos[i];
    return this.parseValor(prod?.medicion15Final) - this.parseValor(prod?.medicion15Previa);
  }

  getDiferenciaMedicion15(i: number): number {

    const volumen15CisternasAprobadas = this.getTotal15(i);

    return this.getTotalMedicion15(i) - volumen15CisternasAprobadas;
  }

  getCantidad(i: number, iMedicion: number): number {
    const m = this.productos[i].medicionesIniciales[iMedicion];
    const r = this.recepcion.recepcionCombustibleContenedores
      .find(x => x.codigoTanque === m.codigoContenedor);
    return Number(r?.cantidad ?? 0);
  }

  getCantidad15(i: number, iMedicion: number): number {
    const m = this.productos[i].medicionesIniciales[iMedicion];
    const r = this.recepcion.recepcionCombustibleContenedores
      .find(x => x.codigoTanque === m.codigoContenedor);
    return Number(r?.cantidad15 ?? 0);
  }

  getTotalNatual(index: number) {
    return Number(this.totales[index]?.natural || 0);
  }

  getTotal15(index: number) {
    return Number(this.totales[index]?.a15 || 0);
  }

  get calidadProducto() {
    return this.recepcionForm.get('calidadProducto') as FormArray;
  }

  get detalleCisternas() {
    return this.recepcionForm.get('detalleCisternas') as FormArray;
  }

  get medicionInicial() {
    return this.recepcionForm.get('medicionInicial') as FormArray;
  }

  get medicionFinal() {
    return this.recepcionForm.get('medicionFinal') as FormArray;
  }

  get prefijoRemito() {
    return this.recepcionForm.get('prefijoRemito') as FormControl;
  }

  get domicilioTransportista() {
    return this.recepcionForm.get('domicilioTransportista') as FormControl;
  }

  get cuitTransportista() {
    return this.recepcionForm.get('cuitTransportista') as FormControl;
  }

  get nombreTransportista() {
    return this.recepcionForm.get('nombreTransportista') as FormControl;
  }

  get nombreConductor() {
    return this.recepcionForm.get('nombreConductor') as FormControl;
  }

  get dniConductor() {
    return this.recepcionForm.get('dniConductor') as FormControl;
  }

  get patenteAcoplado() {
    return this.recepcionForm.get('patenteAcoplado') as FormControl;
  }

  get patenteCamion() {
    return this.recepcionForm.get('patenteCamion') as FormControl;
  }

  get precintoDesde() {
    return this.recepcionForm.get('precintoDesde') as FormControl;
  }

  get precintoHasta() {
    return this.recepcionForm.get('precintoHasta') as FormControl;
  }

  get precintoFijo() {
    return this.recepcionForm.get('precintoFijo') as FormControl;
  }

  get numeroRemito() {
    return this.recepcionForm.get('numeroRemito') as FormControl;
  }

  get terminal() {
    return this.recepcionForm.get('terminal') as FormControl;
  }

}
